'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Cursor utils
 */

var Cursor = {
  moveCursorToEnd: function moveCursorToEnd(div) {
    var range = document.createRange();
    range.selectNodeContents(div);
    range.collapse(false);
    var selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
  },
  createRange: function createRange(node, chars, range) {
    if (!range) {
      range = document.createRange();
      range.selectNode(node);
      range.setStart(node, 0);
    }

    if (chars.count === 0) {
      range.setEnd(node, chars.count);
    } else if (node && chars.count > 0) {
      if (node.nodeType === Node.TEXT_NODE) {
        if (node.textContent.length < chars.count) {
          chars.count -= node.textContent.length;
        } else {
          range.setEnd(node, chars.count);
          chars.count = 0;
        }
      } else {
        for (var lp = 0; lp < node.childNodes.length; lp += 1) {
          range = this.createRange(node.childNodes[lp], chars, range);

          if (chars.count === 0) {
            break;
          }
        }
      }
    }

    return range;
  },
  moveCursorToPosition: function moveCursorToPosition(div, postion) {
    var selection = window.getSelection();
    var range = this.createRange(div.parentNode, {
      count: postion
    });

    if (range) {
      range.collapse(false);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  },
  isChildOf: function isChildOf(node, parentId) {
    while (node !== null) {
      if (node.id === parentId) return true;
      node = node.parentNode;
    }

    return false;
  },
  getCaretPosition: function getCaretPosition(parent) {
    var selection = window.getSelection();
    var charCount = -1;
    var node = void 0;
    if (!selection.focusNode || !this.isChildOf(selection.focusNode, parent.id)) return charCount;
    node = selection.focusNode;
    charCount = selection.focusOffset;

    while (node) {
      if (node.id === parent.id) break;

      if (node.previousSibling) {
        node = node.previousSibling;
        charCount += node.textContent.length;
      } else {
        node = node.parentNode;
        if (node === null) break;
      }
    }

    return charCount;
  },
  fixLineBreak: function fixLineBreak(e) {
    e.preventDefault(); // Prevent default browser behavior

    if (window.getSelection) {
      var selection = window.getSelection();
      var range = selection.getRangeAt(0);
      var br = document.createElement('br');
      var textNode = document.createTextNode('\xA0'); // Passing " " directly will not end up being shown correctly

      range.deleteContents();
      range.insertNode(br);
      range.collapse(false);
      range.insertNode(textNode);
      range.selectNodeContents(textNode);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('delete');
      return false;
    }
  }
};
exports["default"] = Cursor;